import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { AppLoginPrincipalContainerModel } from '../../../../../models/aggregates/app-login';
import { ApiVisa, PagingResponseModel, Pagination, ApiResponseModel } from '../shared';
import {
  AppLoginCriteriaModelQuery,
  AppLoginQueryCriteriaClass,
  AppLoginPrincipalQueryCriteriaClass,
  AppLoginPrincipalCriteriaModelQuery,
} from '../../criteria';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppLoginPrincipalTenantService extends BaseApiTemplateService<AppLoginPrincipalContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-login-principal';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-login-principal';
    this.httpClient = http;
  }

  private setUrl(endpoint: string){
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-login-principal' + endpoint;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-login-principal' + endpoint;
  }

  sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.getByCriteria(pagination, apiVisa);
  }

  getAppLoginTenantPrincipalByCriteria(visa: ApiVisa, criteria?: AppLoginPrincipalQueryCriteriaClass):
    Observable<PagingResponseModel<AppLoginPrincipalContainerModel>> {
    const buildEntityCriteriaCriteria = new AppLoginPrincipalCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<AppLoginPrincipalContainerModel>>(visa.api_domain_url + this.endpoint_path + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }

  public checkUser(value: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '?principal_type=EMAIL_USERNAME&status=USER_CONFIRMED&principal_id=' + value;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '?type=EMAIL_USERNAME&value=' + value;
    }
    return this.httpClient.post<ApiResponseModel<any>>(url, body, this.getHttpHeader(visa));

  }
}
